import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAllTemplatesExchangeListAction,
  getTemplateExchangeCountAction,
} from '../../store/actions';
import { getInsightHealthTemplatesListAction } from '../../store/actions/templatesexchange.action';
import { Bars } from 'react-loader-spinner';
import './TemplatesExchangeModal.scss';
import TemplatesExchange from './TemplatesExchange';
import DotPhrase from './DotPhrase';
import { DotPhraseIcon, NoteTemplateIcon } from 'src/icons';
import { useAuth } from '@frontegg/react';
import { analytics } from 'src/services';

const AuraTemplates = () => {
  const dispatch = useDispatch();
  const {
    getAllTemplatesExchangeList,
    getAllDotPhraseList,
    templateExchangeCount,
    getInsightHealthTemplatesList,
  } = useSelector((state) => state.templatesState);

  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  const [templatesComponent, setTemplatesComponent] = useState(false);
  const [dotPhraseComponent, setDotPhraseComponent] = useState(false);

  const templatelength = templateExchangeCount?.template_count;
  const dotphraselength = templateExchangeCount?.dot_phrase_count;

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(getTemplateExchangeCountAction());
      setLoading(false);
    };
    fetchData();
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllTemplatesExchangeListAction());
    dispatch(getInsightHealthTemplatesListAction());
  }, [dispatch]);

  useEffect(() => {
    analytics.track('Viewed Templates Exchange', { email: user?.email });
  }, [user?.email]);

  const handleComponent = (component) => {
    if (component === 'templates') {
      setTemplatesComponent(true);
      setDotPhraseComponent(false);
      analytics.track('Clicked Note Templates Tile In Templates Exchange', {
        email: user?.email,
      });
    } else if (component === 'dotPhrase') {
      setTemplatesComponent(false);
      setDotPhraseComponent(true);
      analytics.track('Clicked Dot Phrases Tile In Templates Exchange', {
        email: user?.email,
      });
    }
  };

  if (loading) {
    return (
      <div className="page-wrapper flex justify-center items-center absolute inset-0">
        <div>
          <Bars
            height="25"
            width="25"
            color="#00D090"
            ariaLabel="bars-loading"
            visible={true}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={`templatesexchange page-wrapper`}>
      {!templatesComponent && !dotPhraseComponent && (
        <div>
          <div className="text-5xl text-center text-black font-bold mr-1 mt-28">
            Templates exchange
          </div>
          <div className="tabs flex justify-center items-center mt-16 gap-10">
            <div
              className="border-0 text-xl cursor-pointer py-10 text-left px-9 bg-[#f8f8f8] hover:bg-[#e5e5e5] rounded-xl shadow-xl w-[235px]"
              onClick={() => handleComponent('templates')}
              id="note_template_tab"
            >
              <div className="text-2xl text-[#018749]">
                <NoteTemplateIcon />
              </div>
              <p className="mt-5 text-black font-semibold	">Note templates</p>
              <p className="text-base font-medium">
                {templatelength} note templates
              </p>
            </div>
            <div
              className="border-0 text-xl cursor-pointer py-10 text-left px-9 bg-[#f8f8f8] hover:bg-[#e5e5e5] rounded-xl shadow-xl w-[235px]"
              onClick={() => handleComponent('dotPhrase')}
              id="dot_phrase_tab"
            >
              <div className="text-2xl text-[#ff6f00]">
                <DotPhraseIcon />
              </div>
              <p className="mt-5 text-black font-semibold	">Dot phrases</p>
              <p className="text-base font-medium">
                {dotphraselength} dot phrases
              </p>
            </div>
          </div>
        </div>
      )}
      {templatesComponent && (
        <TemplatesExchange
          setTemplatesComponent={setTemplatesComponent}
          templateOverridesList={getAllTemplatesExchangeList}
          insightHealthTemplatesList={getInsightHealthTemplatesList}
        />
      )}
      {dotPhraseComponent && (
        <DotPhrase
          setDotPhraseComponent={setDotPhraseComponent}
          dotPhraseList={getAllDotPhraseList}
          templateOverridesList={getAllTemplatesExchangeList}
        />
      )}
    </div>
  );
};

export default AuraTemplates;
